const skills = [
  {
    section: 'Frontend',
    description:
      'React, JavaScript, DOM manipulation, HTML5, React router, ES6-ES9, Redux, AJAX, jQuery.',
  },
  {
    section: 'CSS / UI',
    description:
      'CSS3, Sass, BEM, Semantic UI, CSS in JS (Aphrodite), Tailwind, Bootstrap, Wix/WordPress.',
  },
  {
    section: 'Computer Science',
    description: 'OOP Fundamentals, Data Structures, Algorithms.',
  },
  {
    section: `Version Control${'\n'}Unix`,
    description:
      'Git/GitHub collaboration, Git/GitLab version control, Unix/Linux, Command Line, VIM.',
  },
  {
    section: 'Backend',
    description:
      'MongoDB (Mongoose), Node.js, Express.js, RESTful Routes, Firebase, graphQL.',
  },
];

export default skills;
